/* 
mixin local para ser importado em cada componente
O mixin global é definido no main.js
 */
import Swal from "sweetalert2";
export default{
    methods: {
        async mensagem_old(mensagem, titulo="", tipo="success"){ //causa erro fecha os v-dialog
            await this.$swal({
                title: titulo,
                text: mensagem,
                icon: tipo,
                allowOutsideClick:false,
                confirmButtonText: 'Ok',
            })
        },
        async mensagem(mensagem, titulo, tipo="success", tempo=1){
            await Swal.fire({
                position: "center",
                icon: tipo,
                title: titulo,
                text: mensagem,
                showConfirmButton: true,
                closeOnClickOutside: false,
                timer: tempo*1000,
              });
        },
        async mensagemPergunta(mensagem, titulo, tipo="question"){
            try {
                /* let result = await this.$swal({ */
                let result = await Swal.fire({
                    title: titulo,
                    text: mensagem,
                    icon: tipo,
                    showCancelButton:true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não',
                    reverseButtons:true
                })
                return result.isConfirmed;
            } catch (error) {
                ////console.log(error)
            }
        }
    },
}